import { render } from "./SyncWordsSettingsFields.vue?vue&type=template&id=005ceee7"
import script from "./SyncWordsSettingsFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncWordsSettingsFields.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/SyncWordsSettingsFields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "005ceee7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('005ceee7', __exports__)) {
    api.reload('005ceee7', __exports__)
  }
  
  module.hot.accept("./SyncWordsSettingsFields.vue?vue&type=template&id=005ceee7", () => {
    api.rerender('005ceee7', render)
  })

}


export default __exports__